import VInputPhone from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputPhone', VInputPhone),
};
